var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotswana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.944375 13.9129C0.331719 15.8324 -7.81112e-05 17.8771 1.37933e-08 19.9999C-7.81112e-05 22.1225 0.331719 24.1673 0.944453 26.0868L20 26.9565L39.0555 26.0868C39.668 24.1673 39.9999 22.1224 39.9999 20C39.9999 17.8773 39.6681 15.8324 39.0555 13.9129L19.9999 13.0434L0.944375 13.9129Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 18.8135 39.8961 17.6513 39.6979 16.5216H0.302187C0.103906 17.6513 0 18.8133 0 19.9999C0 21.1864 0.103984 22.3485 0.302187 23.4782H39.6979C39.896 22.3484 40 21.1864 40 20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C28.9231 39.9999 36.4802 34.1559 39.0555 26.0868H0.944458C3.51985 34.1558 11.077 39.9997 20 39.9999V39.9999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 3.13307e-09C11.077 3.13307e-09 3.52001 5.84398 0.944458 13.9129L39.0554 13.913C36.4802 5.84398 28.9231 -0.000156247 20.0001 3.13307e-09V3.13307e-09Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotswana);
export default __webpack_public_path__ + "static/media/botswana.16886920a4605d4886b6b2362b18dfe7.svg";
export { ForwardRef as ReactComponent };